import { request } from '@/service/request';
import Api from './types'

/** 获取系统信息 */
export function fetchGetSystemSetting() {
    return request<Api.SystemSetting>({
        url: '/ys-digital-commerce/sysTenantInfo/getSysTentedDetail',
        method: 'get'
    });
}

/** 编辑系统信息 */
export function fetchEditSystemSetting(params: Api.SystemSetting) {
    return request<Api.CommonEmpty>({
        url: '/ys-digital-commerce/sysTenantInfo/edit',
        method: 'post',
        data: {
            ...params
        }
    });
}

/** 获取系统更新日志 */
export function fetchGetSystemUpdateLog() {
    return request<Api.SystemUpdateLog>({
        url: '/ys-digital-commerce/sysTenantVersionLog/list',
        method: 'get'
    });
}